import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import {
  Switch,
  Checkbox,
  InputNumber,
  Flex,
  Row,
  Col,
  Button,
  Form,
  Input,
  Drawer,
  message,
  Watermark,
  Space,
  Divider,
  Card,
  Dropdown,
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  SmileOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { PrinterOutlined, BarsOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useDebounce } from "../Helper/hocks.ts";
import { EvidenzDatenListe } from "./EvidenzDatenListe.jsx";
import { EvidenzDatenDetails } from "./EvidenzDatenDetails.jsx";
import { EvidenzDatenEmails } from "./EvidenzDatenEmails.jsx";

export const EvidenzDaten = ({ gruppe }) => {
  const {
    checkRole,
    checkRoles,
    setCookie,
    getCookie,
    eventDataPost,
    eventDataDelete,
    getApiBaseUrl,
    apiBaseUrl,
    aktPdfDaten,
    setAktPdfDaten,
    checkMainContainerHeight,
    logoutLogin,
    killBearer,
  } = LayoutData();
  const { user, userDaten, windowWidth, aktSumsComponent, logout } =
    LayoutData();
  const [suchbegriff, setSuchbegriff] = useState(window.sessionStorage.getItem(`EvSuche`));
  const [dataSource, setDataSource] = useState();
  const debouncedSuchbegriff = useDebounce(suchbegriff);
  const [url1, setUrl1] = useState();
  const [aktEvadrRecNr, setAktEvadrRecNr] = useState(0);
  const [showDrawer1, setShowDrawer1] = useState();
  const [editDrawerCaption1, setEditDrawerCaption1] = useState();
  const [showDrawer2, setShowDrawer2] = useState();
  const [editDrawerCaption2, setEditDrawerCaption2] = useState();
  const [headName,setHeadName]=useState();

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl && debouncedSuchbegriff !== "") {
      setUrl1(
        `${apiBaseUrl}api/evdatensuche?Suchbegriff=${debouncedSuchbegriff}&art=${gruppe}`
      );
      window.sessionStorage.setItem(`EvSuche`,debouncedSuchbegriff);
    }
  }, [apiBaseUrl, debouncedSuchbegriff, gruppe]);

  const {
    isPending: isPending1,
    error: error1,
    data: evidenzData,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        })
          .then((res) => {
            if (res.status === 401) logoutLogin();
            if (!res.ok) {
              console.log("Network response", res);
              throw new Error("Network response not ok");
            }
            return res.json();
          })
          .catch((error) => {
            console.error("XXX Error fetching data:", error);
            // Hier kannst du entscheiden, wie du mit dem Fehler umgehen möchtest
            throw error; // Reicht den Fehler weiter, damit er von der aufrufenden Funktion behandelt werden kann
          });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        console.log("XXX Kein url1 definiert", url1);
        return []; // Promise.resolve({});
      }
    },
  });

  if (error1) {
    //console.log("url1", url1);
    console.error("XXX Error", error1);
    //aktSumsComponent(<> <div style={{color:"red"}} >Fehler</div></>);
    //logout();
  }

  useEffect(() => {
    if (evidenzData && Array.isArray(evidenzData)) {
      console.log("XXX evidenzData", evidenzData);
      const newData = evidenzData.map((item, index) => ({
        ...item,
        key: index,
      }));
      aktSumsComponent(
        <Flex wrap gap={"small"} style={{ overflow: "auto" }}>
          <div>{newData.length} Datensätze gefunden</div>
        </Flex>
      );
      //checkMainContainerHeight();
      setDataSource(newData);
    } else setDataSource([]);
  }, [evidenzData]);
  const onSuchbegriffChanged = (e) => {
    // console.log(e.target.value);
    setSuchbegriff(e.target.value);
  };
  const tableTitle = () => {
    return (
      <Space direction="vertical">
        <Form
          layout="horizontal"
          //onFinish={onSuchbegriffFinish}
          initialValues={{ suchbegriff: suchbegriff }}
        >
          <Row gutter={1}>
            <Col span={20}>
              <Form.Item
                label="Suchbegriff:"
                name="suchbegriff"
                rules={[
                  {
                    required: true,
                    message: "Bitte geben Sie mindestens einen Buchstaben ein!",
                  },
                ]}
              >
                <Input
                  placeholder="Suchbegriff A?B"
                  //required
                  prefix={<SearchOutlined />}
                  onChange={onSuchbegriffChanged}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={4}>
              <div style={{ fontWeight: "bold", marginLeft: 8, marginTop: 5 }}>
                {gruppe === 1 ? (
                  <>
                    <nobr>Acon-Evidenz</nobr>
                  </>
                ) : (
                  <>
                    <nobr>Printex-Evidenz</nobr>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </Space>
    );
  };

  const handleOnEMailsClick = (daten) => {
    console.log("handleOnEMailsClick ",daten);
    setAktEvadrRecNr(daten.id);
    setHeadName(daten.name);
    setShowDrawer2(true);
  };
  const handleOnDetailClick = (daten) => {
    console.log("handleOnDetailClick ",daten);
    setAktEvadrRecNr(daten.id);
    setShowDrawer1(true);
  };
  return (
    <>
      <div className="page">
        <EvidenzDatenListe
          gruppe={gruppe}
          title={tableTitle}
          dataSource={dataSource}
          loading={isPending1}
          handleOnDetailClick={handleOnDetailClick}
          handleOnEMailsClick={handleOnEMailsClick}
        />

        <Drawer
          destroyOnClose
          open={showDrawer1}
          title={editDrawerCaption1 && editDrawerCaption1}
          onClose={() => setShowDrawer1(false)}
          loading={false}
          width={400}
        >
          <EvidenzDatenDetails
            aktEvadrRecNr={aktEvadrRecNr}
            setTitel={setEditDrawerCaption1}
            gruppe={gruppe}
          />
        </Drawer>
        <Drawer
          destroyOnClose
          open={showDrawer2}
          title={editDrawerCaption2 && editDrawerCaption2}
          onClose={() => setShowDrawer2(false)}
          placement="left"
          loading={false}
          width={400}
          //style={{ background: '#f0f0f0', padding: '2px' }} //
        >
          <EvidenzDatenEmails
            aktEvadrRecNr={aktEvadrRecNr}
            setTitel={setEditDrawerCaption2}
            headName={headName}
            gruppe={gruppe}
          />
        </Drawer>
      </div>
    </>
  );
};
